// extracted by mini-css-extract-plugin
export default {"root":"kgU1Lyl5rvCwLdsEcANI","header":"uGW78oY7zvLYDGsAJ5Xj","content":"oyZ48fC74TGfhuaIxDie"};